export const DASHBOARD = 'dashboard'
export const MODULE_INFO = 'module-info'
export const PERMISSION_DENIED = 'permission-denied'
